import React from 'react';
import PropTypes from 'prop-types';
import withTimeout from './withTimeout';


class Spinner extends React.Component {
    constructor(props) {
        super(props);     

        this.state = {
            show:false
        };

        this.show = this.show.bind(this);
    }

    componentDidMount() {
        this.props.setTimeout(this.show, 200);
    }

    show() {
        this.setState({show: true});
    }

    render() {
        return (this.state.show && <div className="loader"></div>);
    }
}                                   

Spinner.propTypes = {
    setTimeout: PropTypes.func.isRequired
};

export default withTimeout(Spinner);


// WEBPACK FOOTER //
// ./src/common/progress/Spinner.js